import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';
const profileImage = require('../../assets/pp.png');


interface HeaderProps {
  onThemeToggle?: () => void;
  isDarkTheme?: boolean;
}

const Header = ({ onThemeToggle, isDarkTheme = false }: HeaderProps) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const navItems = [
    { href: '/', icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
        <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>
      </svg>
    )},
    { label: 'Hakkımda', href: '/hakkimda' },
    { label: 'Projelerim', href: '/projeler' },
    { label: 'Hizmetlerim', href: '/hizmetler' }
  ];

  const socialLinks = [
    { 
      name: 'LinkedIn', 
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
          <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
        </svg>
      ), 
      href: 'https://linkedin.com/in/egeavci' 
    },
    { 
      name: 'Gmail', 
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
          <path d="M24 5.457v13.909c0 .904-.732 1.636-1.636 1.636h-3.819V11.73L12 16.64l-6.545-4.91v9.273H1.636A1.636 1.636 0 0 1 0 19.366V5.457c0-.904.732-1.636 1.636-1.636h.91L12 10.09l9.455-6.27h.909c.904 0 1.636.732 1.636 1.636z"/>
        </svg>
      ), 
      href: 'mailto:ege@example.com' 
    },
    { 
      name: 'GitHub', 
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
        </svg>
      ), 
      href: 'https://github.com/egeavci' 
    }
  ];

  return (
    <header className="header">
      <div className="header-container">
        {/* Left Section - Social Icons */}
        <div className="header-left">
          {socialLinks.map((social, index) => (
            <a
              key={index}
              href={social.href}
              className="social-icon"
              aria-label={social.name}
              target="_blank"
              rel="noopener noreferrer"
            >
              {social.icon}
            </a>
          ))}
        </div>

        {/* Center Section - Profile */}
        <div className="header-center">
          <div className="profile-container">
            <div className="profile-image">
              <img src={profileImage} alt="Ege Avcı" />
            </div>
            <span className="profile-name">Ege Avcı</span>
          </div>
        </div>

        {/* Right Section - Navigation & Theme Toggle */}
        <div className="header-right">
          {/* Desktop Navigation */}
          <nav className="header-nav desktop-nav">
            {navItems.map((item, index) => (
              <Link 
                key={index} 
                to={item.href} 
                className={`nav-link ${location.pathname === item.href ? 'active' : ''}`}
              >
                {item.icon && <span className="nav-icon">{item.icon}</span>}
                {item.label}
              </Link>
            ))}
          </nav>

          {/* Theme Toggle */}
          <button 
            className="theme-toggle"
            onClick={onThemeToggle}
            aria-label="Toggle theme"
          >
            {isDarkTheme ? '☀️' : '🌙'}
          </button>
          
          {/* Mobile Menu Toggle */}
          <button 
            className="mobile-menu-toggle"
            onClick={toggleMenu}
            aria-label="Toggle menu"
          >
            <span className={`hamburger ${isMenuOpen ? 'active' : ''}`}>
              <span></span>
              <span></span>
              <span></span>
            </span>
          </button>
        </div>

        {/* Mobile Navigation Overlay */}
        {isMenuOpen && (
          <div className="mobile-overlay" onClick={toggleMenu}></div>
        )}
        
        {/* Mobile Navigation */}
        <nav className={`header-nav mobile-nav ${isMenuOpen ? 'active' : ''}`}>
          {navItems.map((item, index) => (
            <Link 
              key={index} 
              to={item.href} 
              className={`nav-link ${location.pathname === item.href ? 'active' : ''}`}
              onClick={() => setIsMenuOpen(false)}
            >
              {item.icon && <span className="nav-icon">{item.icon}</span>}
              {item.label}
            </Link>
          ))}
          {/* Mobile Theme Toggle */}
          <div className="mobile-theme-toggle">
            <button 
              className="theme-toggle mobile-theme-btn"
              onClick={onThemeToggle}
              aria-label="Toggle theme"
            >
              {isDarkTheme ? '☀️' : '🌙'}
            </button>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
